/**
 * Copy used when a visitor is escalated from bot to human.
 * The public website / bot should send this (or equivalent) before a rep joins — not the admin SPA.
 * Kept here so product/docs and any future shared package stay aligned.
 */
export const LEAD_TRANSFER_TO_REPRESENTATIVE_MESSAGE =
  'Let me transfer you to a representative…';
